
angular.module('ui.message', ['templates']);
